import { SNGPCCompany, SNGPCResponsible } from '../../interfaces/sngpc';

export interface SNGPCState {
  readonly empresas: SNGPCCompany[];
  readonly transactionToken: string;
  readonly empresaSelecionada: SNGPCCompany | null;
  readonly responsavelSelecionado: SNGPCResponsible | null;
  error: string | null;
  loading: boolean;
  currentStep: number;
}

export enum ActionTypes {
  FETCH_COMPANIES = 'sngpc/FETCH_COMPANIES',
  FETCH_COMPANIES_SUCCESS = 'sngpc/FETCH_COMPANIES_SUCCESS',
  FETCH_COMPANIES_ERROR = 'sngpc/FETCH_COMPANIES_ERROR',
  HANDLE_SELECTED_COMPANY = 'sngpc/HANDLE_SELECTED_COMPANY',
  CREATE_USER = 'sngpc/CREATE_USER',
  CREATE_USER_SUCCESS = 'sngpc/CREATE_USER_SUCCESS',
  CREATE_USER_ERROR = 'sngpc/CREATE_USER_ERROR',
  GO_BACK = 'sngpc/GO_BACK',
  RESET_STATE = 'sngpc/RESET_STATE',
}

export interface ResetStateAction {
  type: ActionTypes.RESET_STATE;
}

export interface GoBackAction {
  type: ActionTypes.GO_BACK;
}

export interface CreateUserAction {
  type: ActionTypes.CREATE_USER;
}

export interface CreateUserSuccessAction {
  type: ActionTypes.CREATE_USER_SUCCESS;
  payload: any; // @todo: Alinhar com o time de backend como será essa interface de resposta
}

export interface CreateUserErrorAction {
  type: ActionTypes.CREATE_USER_ERROR;
  payload: {
    error: string | null;
  };
}

export interface HandleSelectedCompanyAction {
  type: ActionTypes.HANDLE_SELECTED_COMPANY;
  payload: SNGPCState;
}

export interface FetchCompaniesAction {
  type: ActionTypes.FETCH_COMPANIES;
}

export interface FetchCompaniesSuccessAction {
  type: ActionTypes.FETCH_COMPANIES_SUCCESS;
  payload: SNGPCState;
}

export interface FetchCompaniesErrorAction {
  type: ActionTypes.FETCH_COMPANIES_ERROR;
  payload: {
    error: string | null;
  };
}

export type Action =
  | GoBackAction
  | ResetStateAction
  | CreateUserAction
  | CreateUserSuccessAction
  | CreateUserErrorAction
  | FetchCompaniesAction
  | FetchCompaniesSuccessAction
  | FetchCompaniesErrorAction
  | HandleSelectedCompanyAction;
